import visa from "../images/visa.png";
import paypal from "../images/paypal.png";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Checkout = ({ setCart, setChecking }) => {
  const [tab, setTab] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from?.pathname || "/";

  const handleConfirmCart = () => {
    alert("Your order was successfully placed!");
    localStorage.removeItem("cart");
    setCart([]);
    navigate(from, { replace: true });
    window.scrollTo({ top: 0 });
    setChecking(false);
  };
  return (
    <div className="py-[20px] px-[10px] rounded-[10px] w-[400px] bg-white flex flex-col items-start justify-start">
      <h2 className="mb-[20px] text-left font-[700] text-[18px]">
        Select Your Payment Method
      </h2>
      <div className="flex items-center justify-center w-[100%] border-t-[1px] pt-[20px]">
        <button
          onClick={() => setTab(true)}
          id="visa"
          className={`px-[10px] ${tab ? "border-t-[3px] border-blue-600" : ""}`}
        >
          <img src={visa} alt="" className="h-[30px]" />
        </button>
        <button
          onClick={() => setTab(false)}
          id="paypal"
          className={`px-[10px] ${
            !tab ? "border-t-[3px] border-blue-600" : ""
          }`}
        >
          <img src={paypal} alt="" className="h-[30px]" />
        </button>
      </div>

      {/* Tab content */}
      {/* Visa */}
      {tab ? (
        <div className="flex flex-col items-center justify-center pt-[30px]">
          <h2 className="text-center font-[600] text-[20px] mb-[50px]">
            Debit Card
          </h2>
          <div
            id="cardname"
            className="border-b-[1px] border-gray-300 w-[350px] relative my-[15px]"
          >
            <input
              type="text"
              name="Name"
              className="w-[100%] transition-all duration-500 ease-in-out"
              required
            />
            <label className="absolute top-[0px] left-0 transition-all duration-500 ease-in-out">
              Cardholder Name
            </label>
          </div>
          <div
            id="cardname"
            className="border-b-[1px] border-gray-300 w-[350px] relative my-[15px]"
          >
            <input
              type="number"
              name="CardNumber"
              className="appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [-moz-appearance:textfield] w-[100%] transition-all duration-500 ease-in-out"
              required
            />
            <label className="absolute top-[0px] left-0 transition-all duration-500 ease-in-out">
              Card Number
            </label>
          </div>
          <div className="flex gap-2">
            <div
              id="cardname"
              className="border-b-[1px] border-gray-300 w-[170px] relative my-[15px]"
            >
              <input
                type="text"
                name="Expiration"
                className="w-[100%] transition-all duration-500 ease-in-out"
                required
              />
              <label className="absolute top-[0px] left-0 transition-all duration-500 ease-in-out">
                Expiration Date
              </label>
            </div>
            <div
              id="cardname"
              className="border-b-[1px] border-gray-300 w-[170px] relative my-[15px]"
            >
              <input
                type="number"
                name="CVV"
                className="appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [-moz-appearance:textfield] w-[100%] transition-all duration-500 ease-in-out"
                required
              />
              <label className="absolute top-[0px] left-0 transition-all duration-500 ease-in-out">
                CVV
              </label>
            </div>
          </div>
          <button
            onClick={handleConfirmCart}
            className="mt-[20px] bg-green-700 text-white py-[5px] px-[20px] rounded-[30px] hover:bg-green-800"
          >
            Order Now
          </button>
        </div>
      ) : (
        ""
      )}
      {/* Paypal */}
      {!tab ? (
        <div className="flex flex-col items-center justify-center pt-[30px]">
          <h2 className="text-center font-[600] text-[20px] mb-[50px]">
            Paypal Account Info
          </h2>
          <div
            id="cardname"
            className="border-b-[1px] border-gray-300 w-[350px] relative my-[15px]"
          >
            <input
              type="email"
              name="Name"
              className="w-[100%] transition-all duration-500 ease-in-out"
              required
            />
            <label className="absolute top-[0px] left-0 transition-all duration-500 ease-in-out">
              Your Email
            </label>
          </div>
          <div
            id="cardname"
            className="border-b-[1px] border-gray-300 w-[350px] relative my-[15px]"
          >
            <input
              type="text"
              name="Name"
              className="w-[100%] transition-all duration-500 ease-in-out"
              required
            />
            <label className="absolute top-[0px] left-0 transition-all duration-500 ease-in-out">
              Your Name
            </label>
          </div>
          <div className="flex gap-2">
            <div
              id="cardname"
              className="border-b-[1px] border-gray-300 w-[350px] relative my-[15px]"
            >
              <input
                type="text"
                name="Name"
                className="w-[100%] transition-all duration-500 ease-in-out"
                required
              />
              <label className="absolute top-[0px] left-0 transition-all duration-500 ease-in-out">
                Extra Info
              </label>
            </div>
          </div>
          <button className="mt-[20px] bg-blue-700 text-white py-[5px] px-[20px] rounded-[30px] hover:bg-blue-800">
            Add Paypal
          </button>
          <p className="mt-[30px]">
            <em>Payment Disclaimer:</em> In no event shall payment or partial
            payment by Owner for any material or service.
          </p>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Checkout;
